import { Package } from "react-feather"

const komparasi = [{
    id: 'komparasi-data',
    title: 'Komparasi Data',
    icon: <Package size={20} />,
    navLink: '/komparasi-data'
  }]

export default komparasi